import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "text-1u883",
  "use": "text-1u883-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"text-1u883\"><path fill-rule=\"evenodd\" d=\"M10.231 14.155l-1.52-.37-.329-.452V1.643h3.061c.165 1.13.493 2.117.904 2.877h1.233V0H0v4.52h1.233c.41-.76.719-1.746.904-2.876h3.06V13.58l-1.848.575v.843h6.882v-.843z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol